// src/services/loadingController.js
let showFn = () => {};
let hideFn = () => {};

export const setLoadingHandlers = (show, hide) => {
  showFn = show;
  hideFn = hide;
};

export const loadingController = {
  show: () => showFn(),
  hide: () => hideFn(),
};
